<script setup lang="ts">
import type { PreparedAuctionItem } from '@autobid/ui/types/components/AuctionsData'
import { inject } from 'vue'

const auction = inject<PreparedAuctionItem>('auction')
</script>

<template>
  <div
    class="my-auto hidden h-full w-full items-center justify-center bg-white p-2 group-hover:bg-slate-100 @lg:flex"
  >
    <img
      v-if="auction?.image"
      :alt="auction?.title"
      class="max-h-[48px]"
      :src="`${auction.image}?v=${auction?.publicationInfo.dataHash.auction}`"
    >
  </div>
</template>
